export enum AdminBoxListItemAction {
  CreateBoxSale,
  Edit,
  Preview,
  PreviewBoxSale,
  CompleteOrders,
  SimulateCompleteOrders,
  DownloadLabels,
  Remove,
  More,
}
